import React from 'react';

export const SectionTitle = ({ eyebrow, title, subtitle, align = 'left' }) => (
  <div className={`max-w-3xl mb-12 ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && (
      <div className={`inline-flex items-center gap-2 text-[#6a8aa4] uppercase tracking-[0.25em] text-xs mb-4 ${align === 'center' ? 'justify-center' : ''}`}>
        {align === 'center' && <span className="w-8 h-[1px] bg-[#6a8aa4]" />}
        <span className="w-8 h-[1px] bg-[#6a8aa4]" /> {eyebrow}
      </div>
    )}
    <h2 className="font-serif text-[#304b71] text-3xl md:text-5xl leading-tight">{title}</h2>
    {subtitle && <p className="mt-5 text-slate-600 leading-relaxed">{subtitle}</p>}
  </div>
);

export default SectionTitle;
